type OrganProps = {
  className: string;
  /** The organ is artwork, so it carries no text of its own. */
  ariaLabel: string;
  /** Omitted where the body is not interactive, such as the PDF report. */
  onSelect?: () => void;
  children: React.ReactNode;
};

export default function Organ({
  className,
  ariaLabel,
  onSelect,
  children,
}: OrganProps) {
  if (!onSelect) return <span className={className}>{children}</span>;

  return (
    <button
      type='button'
      className={className}
      onClick={onSelect}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}
